import React, { useEffect, useRef, useState } from 'react'
import { Button, Overlay, Popover } from 'react-bootstrap'
import api from '../../api';

function HubSpoc({ hubId }) {
    const [hubSpocs, setHubSpocs] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [showPopover, setShowPopover] = useState(false);
    const target = useRef(null);
    const handleToggle = () => setShowPopover((prev) => !prev);
    const handleMouseEnter = () => setShowPopover(true);
    const handleMouseLeave = () => setShowPopover(false);

    const fetchHubSpoc = async () => {
        try {
            setIsFetching(true)
            const response = await api.hubspoc.getDetails({
                resource: `api/hubspoc/${hubId}`,
            });
            setHubSpocs(response.data.data.res);
        } catch (error) {
            console.error(error.message);
        } finally {
            setIsFetching(false)
        }
    };

    const showSpocs = () => {
        if (isFetching) {
            return 'Fetching'
        }
        if (hubSpocs?.length > 0) {
            return <div>
                <p><strong>For Functional Queries</strong></p>
                {hubSpocs?.map((spoc, index) => <p key={index}><span>{spoc.spocname} {spoc.spocemail}</span></p>)}
            </div>
        } else {
            return 'No Data Found!'
        }
    }

    useEffect(() => {
        fetchHubSpoc();
    }, [])

    return (
        <div className="d-flex align-items-center me-2" onClick={handleToggle} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} >
            <Button ref={target} variant="transparent" className='navHeader'>
                Contact
            </Button>
            <Overlay show={showPopover} target={target.current} placement="bottom">
                <Popover>
                    <Popover.Body className={`${isFetching ? '' : hubSpocs?.length > 0 ? 'pb-0' : ''}`}>
                        <p><strong>For Technical/Access Queries</strong></p>
                        <p>internal.apps@agilisium.com</p>
                        {isFetching ? 'Fetching SPOC' : showSpocs()}
                    </Popover.Body>
                </Popover>
            </Overlay>
        </div>
    )
}

export default HubSpoc